import * as React from 'react'
import styled from '@emotion/styled'
import * as allIcons from './icons/all'
import * as cantonIcons from './../materials/icons/cantons'
import { CantonId } from '../domain'
import { parseHostname } from '../lib/parseHostname'
import { breakpoints as bp } from './layout'
import { useContext } from 'react'
import { ColorModeOverrideContext } from '../contexts/ColorModeOverrideContext'

export { default as FlagOfSwitzerland } from './icons/custom/Flag_of_Switzerland.svg'

export type IconName = keyof typeof allIcons

export interface IconProps {
  name: IconName
  color?: string // CSSColor
}

export const Icon = ({ name, color }: IconProps): JSX.Element => {
  if (color !== undefined) {
    return React.createElement<{ style: { color: string } }>(allIcons[name], { style: { color } })
  } else {
    return React.createElement(allIcons[name])
  }
}

export const CantonIcon = ({ name }: { name: CantonId }): JSX.Element | null => {
  const Comp = cantonIcons[name as keyof typeof cantonIcons]
  return Comp ? <Comp /> : null
}

export const Logo = (): JSX.Element => {
  const colorModeOverride = useContext(ColorModeOverrideContext)
  const publicationName = parseHostname().publicationName
  const isDarkmode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
  const imgSrc = `https://interaktiv.tagesanzeiger.ch/static/icons/${
    publicationName +
    ((colorModeOverride && colorModeOverride === 'dark') || (!colorModeOverride && isDarkmode) ? '-inverted' : '')
  }.svg`

  return <Image src={imgSrc} />
}

const Image = styled('img')`
  display: block;

  width: 35px;
  ${bp.medium`height: 36px;min-width: 36px;`};
`

export function Arrow(props: React.ComponentProps<'svg'>) {
  const elementProps: React.ComponentProps<'line'> & React.ComponentProps<'path'> = {
    stroke: 'currentColor',
    fill: 'none',
    strokeLinejoin: 'round',
    strokeLinecap: 'round',
    strokeWidth: 1.5,
  }

  return (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20">
      <line x1="2" x2="18" y1="10" y2="10" {...elementProps} />
      <path d="M 10 2 L 18 10 L 10 18" {...elementProps} />
    </svg>
  )
}
